import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const ReportButtons = forwardRef(({
    label,
    iconClass,
    onClick,
    ariaLabel,
    isDisabled,
}, ref) => {
    return (
        <button
            ref={ref}
            className={`fs-16 text-semibold align-content-center border-0 bg-transparent  ${isDisabled ? "disabled-text" : "hyper-links"
                }`}
            aria-label={ariaLabel || label}
            aria-disabled={isDisabled}
            tabIndex={isDisabled ? -1 : 0}
            onClick={() => {
                if (!isDisabled) onClick();
            }}
            onKeyDown={(e) => {
                if ((e.key === "Enter" || e.key === " ") && !isDisabled) {
                    e.preventDefault(); // Prevent page scroll for Space key
                    onClick();
                }
            }}
            style={{
                cursor: isDisabled ? "not-allowed" : "pointer"
            }}
            aria-live="polite"
        >
            <span>{label}</span>
            {iconClass && <i className={`${iconClass} pl-8p`} aria-hidden="true"></i>}
            <div
                aria-live="polite"
                style={{ position: "absolute", height: 0, width: 0, overflow: "hidden" }}
            >
                {!isDisabled && `${label} button is active`}
            </div>
        </button>
    );
});

ReportButtons.propTypes = {
    label: PropTypes.string,
    iconClass: PropTypes.string,
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string,
    isDisabled: PropTypes.bool,
}

export default ReportButtons;
